module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-200.0bcdf483.woff2";